import { useEffect, useRef, useState } from 'react';

const persist = (record) => {
  if (!record?.enabled || record.blocked || record.serialized === record.baseline) return null;
  try {
    localStorage.setItem(record.key, JSON.stringify({ version: 1, savedAt: Date.now(), form: JSON.parse(record.serialized) }));
    record.baseline = record.serialized;
    return 'Rascunho salvo neste navegador';
  } catch {
    return 'Não foi possível salvar o rascunho local. Use Salvar curso.';
  }
};

export default function useCourseDraft({ userId, courseId, form, enabled }) {
  const key = `courses.editor-draft.v1:${userId}:${courseId || 'new'}`;
  const recordRef = useRef(null);
  const [candidateState, setCandidate] = useState(null);
  const [status, setStatus] = useState('');
  const serialized = JSON.stringify(form);

  useEffect(() => {
    let record = recordRef.current;
    if (!record || record.key !== key) {
      persist(record);
      record = { key, serialized, baseline: serialized, enabled: Boolean(enabled && userId), blocked: false };
      recordRef.current = record;
      setCandidate(null);
      setStatus('');
      if (record.enabled) {
        try {
          const stored = JSON.parse(localStorage.getItem(key) || 'null');
          if (stored?.version === 1 && typeof stored.form?.title === 'string' && Array.isArray(stored.form?.modules) && stored.form.modules.every(module => Array.isArray(module.lessons))) {
            record.blocked = true;
            setCandidate({ key, ...stored });
          }
        } catch {
          setStatus('Não foi possível recuperar o rascunho local.');
        }
      }
    }
    record.serialized = serialized;
    if (record.enabled && !enabled) persist(record);
    record.enabled = Boolean(enabled && userId);
    if (!record.enabled || record.blocked || record.baseline === serialized) return undefined;
    setStatus('Alterações pendentes no rascunho local…');
    const timer = window.setTimeout(() => {
      const result = persist(record);
      if (result) setStatus(result);
    }, 600);
    return () => window.clearTimeout(timer);
  }, [key, serialized, enabled, userId]);

  useEffect(() => {
    const flush = () => persist(recordRef.current);
    window.addEventListener('beforeunload', flush);
    return () => { window.removeEventListener('beforeunload', flush); flush(); };
  }, []);

  const candidate = candidateState?.key === key ? candidateState : null;
  const clear = (nextForm = form) => {
    try { localStorage.removeItem(key); } catch { /* The server save remains available. */ }
    if (recordRef.current?.key === key) {
      recordRef.current.blocked = false;
      recordRef.current.baseline = JSON.stringify(nextForm);
      recordRef.current.serialized = JSON.stringify(nextForm);
    }
    setCandidate(null);
    setStatus('');
  };
  const restore = () => {
    const restored = candidate?.form;
    if (recordRef.current?.key === key) recordRef.current.blocked = false;
    setCandidate(null);
    setStatus('Rascunho recuperado. Salve para atualizar o curso.');
    return restored;
  };
  return { candidate, status, clear, restore };
}
